import { render, staticRenderFns } from "./OrderedList.vue?vue&type=template&id=02884ed1"
import script from "./OrderedList.vue?vue&type=script&lang=js"
export * from "./OrderedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports